import React, { useState, useEffect, useRef } from 'react';
import './DoctorPanel.css';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru/api';

const DoctorPanel = ({ onBack, user }) => {
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [doctorUser, setDoctorUser] = useState(null);
  const [doctorInfo, setDoctorInfo] = useState(null);
  const [activeTab, setActiveTab] = useState('appointments');
  const [isLoading, setIsLoading] = useState(false);
  
  const [appointments, setAppointments] = useState([]);
  const [allPatients, setAllPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientHistory, setPatientHistory] = useState(null);
  const [searchPatientTerm, setSearchPatientTerm] = useState('');
  
  const [testResultForm, setTestResultForm] = useState({
    title: '',
    description: '',
    file: null
  });
  const [showTestModal, setShowTestModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);
  
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('doctorToken');
    const savedDoctor = localStorage.getItem('doctorUser');
    
    if (token && savedDoctor) {
      try {
        const doctorData = JSON.parse(savedDoctor);
        setDoctorUser(doctorData);
        setIsAuthenticated(true);
        loadDoctorInfo(doctorData.doctor_id);
        loadAppointments(doctorData.doctor_id);
        loadAllPatients();
      } catch (e) {
        console.error('Ошибка парсинга:', e);
      }
    }
  }, []);

  const loadDoctorInfo = async (doctorId) => {
    try {
      const response = await fetch(`${API_URL}/doctors/${doctorId}`);
      if (response.ok) {
        const data = await response.json();
        setDoctorInfo(data);
      }
    } catch (error) {
      console.error('Ошибка загрузки информации о враче:', error);
    }
  };

  const loadAppointments = async (doctorId, date = '', status = '') => {
    setIsLoading(true);
    try {
      let url = `${API_URL}/doctor/appointments/${doctorId}`;
      const params = [];
      if (date) params.push(`date=${date}`);
      if (status) params.push(`status=${status}`);
      if (params.length) url += `?${params.join('&')}`;
      
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        setAppointments(data);
      }
    } catch (error) {
      console.error('Ошибка загрузки записей:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadAllPatients = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/users`);
      if (response.ok) {
        const data = await response.json();
        const patients = data.filter(u => u.role === 'patient');
        setAllPatients(patients);
      }
    } catch (error) {
      console.error('Ошибка загрузки пациентов:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadPatientHistory = async (patientId) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctor/patient/${patientId}/history`);
      if (response.ok) {
        const data = await response.json();
        setPatientHistory(data);
      }
    } catch (error) {
      console.error('Ошибка загрузки истории:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateAppointmentStatus = async (appointmentId, status) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctor/appointments/${appointmentId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
      });
      
      if (response.ok) {
        await loadAppointments(doctorUser.doctor_id, selectedDate, selectedStatus);
        alert('✅ Статус записи обновлен');
      } else {
        alert('❌ Ошибка обновления статуса');
      }
    } catch (error) {
      console.error('Ошибка обновления статуса:', error);
      alert('❌ Ошибка при обновлении статуса');
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        alert('❌ Поддерживаются только PDF, JPG, PNG, GIF');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert('❌ Размер файла не должен превышать 10MB');
        return;
      }
      setTestResultForm({ ...testResultForm, file });
    }
  };

  const addTestResult = async () => {
    if (!testResultForm.title) {
      alert('❌ Введите название анализа');
      return;
    }
    
    setIsLoading(true);
    setUploadProgress(0);
    
    try {
      let file_url = '';
      
      if (testResultForm.file) {
        const formData = new FormData();
        formData.append('file', testResultForm.file);
        formData.append('user_id', selectedPatient.id);
        formData.append('doctor_id', doctorUser.doctor_id);
        formData.append('title', testResultForm.title);
        formData.append('description', testResultForm.description);
        
        const xhr = new XMLHttpRequest();
        
        const uploadPromise = new Promise((resolve, reject) => {
          xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable) {
              const progress = Math.round((e.loaded / e.total) * 100);
              setUploadProgress(progress);
            }
          });
          
          xhr.onload = () => {
            if (xhr.status === 200) {
              const response = JSON.parse(xhr.responseText);
              resolve(response);
            } else {
              reject(new Error('Ошибка загрузки'));
            }
          };
          
          xhr.onerror = () => reject(new Error('Ошибка сети'));
        });
        
        xhr.open('POST', `${API_URL}/doctor/upload-test-result`);
        xhr.send(formData);
        
        const result = await uploadPromise;
        file_url = result.file_url;
      } else {
        const response = await fetch(`${API_URL}/doctor/test-results`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: selectedPatient.id,
            doctor_id: doctorUser.doctor_id,
            title: testResultForm.title,
            description: testResultForm.description,
            file_url: ''
          })
        });
        
        if (!response.ok) throw new Error('Ошибка добавления');
      }
      
      await loadPatientHistory(selectedPatient.id);
      setTestResultForm({ title: '', description: '', file: null });
      if (fileInputRef.current) fileInputRef.current.value = '';
      setShowTestModal(false);
      setUploadProgress(0);
      alert('✅ Результат анализа добавлен');
    } catch (error) {
      console.error('Ошибка добавления результата:', error);
      alert('❌ Ошибка при добавлении результата');
    } finally {
      setIsLoading(false);
    }
  };

  const deleteTestResult = async (resultId) => {
    if (window.confirm('Удалить этот результат анализа?')) {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_URL}/doctor/test-results/${resultId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          await loadPatientHistory(selectedPatient.id);
          alert('✅ Результат анализа удален');
        } else {
          alert('❌ Ошибка удаления результата');
        }
      } catch (error) {
        console.error('Ошибка удаления результата:', error);
        alert('❌ Ошибка при удалении результата');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleLogin = async () => {
    if (!loginForm.email || !loginForm.password) {
      setLoginError('Заполните все поля');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: loginForm.email,
          password: loginForm.password
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success && data.user.role === 'doctor') {
        setIsAuthenticated(true);
        setDoctorUser(data.user);
        setLoginError('');
        localStorage.setItem('doctorToken', 'logged_in');
        localStorage.setItem('doctorUser', JSON.stringify(data.user));
        await loadDoctorInfo(data.user.doctor_id);
        await loadAppointments(data.user.doctor_id);
        await loadAllPatients();
      } else {
        setLoginError('Неверный логин или пароль, или у вас нет прав врача');
      }
    } catch (error) {
      console.error('Ошибка входа:', error);
      setLoginError('Ошибка подключения к серверу');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('doctorToken');
    localStorage.removeItem('doctorUser');
    setIsAuthenticated(false);
    setDoctorUser(null);
    setDoctorInfo(null);
    setAppointments([]);
    setAllPatients([]);
    setSelectedPatient(null);
    setPatientHistory(null);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('ru-RU');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'pending': return <span className="status-badge pending">Ожидает</span>;
      case 'confirmed': return <span className="status-badge confirmed">Подтвержден</span>;
      case 'completed': return <span className="status-badge completed">Завершен</span>;
      case 'cancelled': return <span className="status-badge cancelled">Отменен</span>;
      default: return <span className="status-badge">{status}</span>;
    }
  };

  const getFileUrl = (filePath) => {
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = API_URL.replace('/api', '');
    return `${baseUrl}${filePath}`;
  };

  const filteredPatients = allPatients.filter(patient => {
    const search = searchPatientTerm.toLowerCase();
    return patient.first_name?.toLowerCase().includes(search) ||
           patient.last_name?.toLowerCase().includes(search) ||
           patient.email?.toLowerCase().includes(search) ||
           patient.phone?.includes(search);
  });

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');

  if (!isAuthenticated) {
    return (
      <div className="doctor-panel">
        <div className="doctor-header">
          <button className="back-btn-full" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('Назад')}</span>
          </button>
        </div>
        
        <div className="doctor-login-container">
          <div className="doctor-login-card">
            <div className="doctor-login-icon">👨‍⚕️</div>
            <h2>Вход для врачей</h2>
            <p className="doctor-login-subtitle">Введите учетные данные</p>
            
            <div className="doctor-login-form">
              <input
                type="email"
                className="doctor-login-input"
                placeholder="Email"
                value={loginForm.email}
                onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                disabled={isLoading}
              />
              <input
                type="password"
                className="doctor-login-input"
                placeholder="Пароль"
                value={loginForm.password}
                onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                disabled={isLoading}
              />
              {loginError && <div className="doctor-login-error">{loginError}</div>}
              <button className="doctor-login-btn" onClick={handleLogin} disabled={isLoading}>
                {isLoading ? 'Загрузка...' : 'Войти'}
              </button>
              <p className="doctor-login-hint">Демо: doctor@clinic.com / doctor123</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="doctor-panel">
      <div className="doctor-header">
        <button className="back-btn-full" onClick={onBack}>
          <span className="btn-icon">←</span>
          <span className="btn-text">{t('Назад')}</span>
        </button>
        <div className="doctor-user-info">
          <div className="doctor-avatar">
            {doctorInfo?.image_url ? (
              <img src={doctorInfo.image_url} alt={doctorInfo.name} />
            ) : (
              <span>👨‍⚕️</span>
            )}
          </div>
          <div className="doctor-info-text">
            <h3>{doctorInfo?.name || 'Врач'}</h3>
            <p>{doctorInfo?.specialization || 'Специализация'}</p>
          </div>
          <button className="doctor-logout-btn" onClick={handleLogout}>
            🚪 Выйти
          </button>
        </div>
      </div>

      <div className="doctor-tabs">
        <button 
          className={`doctor-tab ${activeTab === 'appointments' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('appointments');
            loadAppointments(doctorUser.doctor_id, selectedDate, selectedStatus);
          }}
        >
          📅 Записи ({appointments.length})
        </button>
        <button 
          className={`doctor-tab ${activeTab === 'patients' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('patients');
            setSelectedPatient(null);
            setPatientHistory(null);
            setSearchPatientTerm('');
          }}
        >
          👥 Все пациенты ({allPatients.length})
        </button>
      </div>

      <div className="doctor-content">
        {activeTab === 'appointments' && (
          <div className="appointments-section">
            <div className="appointments-filters">
              <input
                type="date"
                className="filter-input"
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value);
                  loadAppointments(doctorUser.doctor_id, e.target.value, selectedStatus);
                }}
              />
              <select
                className="filter-select"
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  loadAppointments(doctorUser.doctor_id, selectedDate, e.target.value);
                }}
              >
                <option value="">Все статусы</option>
                <option value="pending">Ожидает</option>
                <option value="confirmed">Подтвержден</option>
                <option value="completed">Завершен</option>
                <option value="cancelled">Отменен</option>
              </select>
            </div>

            <div className="appointments-list">
              {isLoading ? (
                <div className="loading-spinner">Загрузка...</div>
              ) : appointments.length === 0 ? (
                <div className="no-data">Нет записей</div>
              ) : (
                appointments.map((appointment) => (
                  <div key={appointment.id} className="appointment-card">
                    <div className="appointment-header">
                      <div className="patient-name">
                        {appointment.first_name} {appointment.last_name}
                      </div>
                      {getStatusBadge(appointment.status)}
                    </div>
                    <div className="appointment-details">
                      <div className="detail-item">
                        <span className="detail-label">📅 Дата:</span>
                        <span>{formatDate(appointment.appointment_date)}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">⏰ Время:</span>
                        <span>{appointment.appointment_time}</span>
                      </div>
                      {appointment.service_name && (
                        <div className="detail-item">
                          <span className="detail-label">📋 Услуга:</span>
                          <span>{appointment.service_name}</span>
                        </div>
                      )}
                      <div className="detail-item">
                        <span className="detail-label">📞 Телефон:</span>
                        <span>{appointment.phone || '—'}</span>
                      </div>
                    </div>
                    <div className="appointment-actions">
                      {appointment.status === 'pending' && (
                        <button 
                          className="action-btn confirm"
                          onClick={() => updateAppointmentStatus(appointment.id, 'confirmed')}
                        >
                          ✅ Подтвердить
                        </button>
                      )}
                      {appointment.status === 'confirmed' && (
                        <button 
                          className="action-btn complete"
                          onClick={() => updateAppointmentStatus(appointment.id, 'completed')}
                        >
                          ✔️ Завершить
                        </button>
                      )}
                      {(appointment.status === 'pending' || appointment.status === 'confirmed') && (
                        <button 
                          className="action-btn cancel"
                          onClick={() => updateAppointmentStatus(appointment.id, 'cancelled')}
                        >
                          ❌ Отменить
                        </button>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {activeTab === 'patients' && (
          <div className="patients-section">
            {!selectedPatient ? (
              <div className="patients-list">
                <div className="patients-search">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="🔍 Поиск пациентов по имени, email или телефону..."
                    value={searchPatientTerm}
                    onChange={(e) => setSearchPatientTerm(e.target.value)}
                  />
                </div>
                {filteredPatients.map((patient) => (
                  <div 
                    key={patient.id} 
                    className="patient-card"
                    onClick={() => {
                      setSelectedPatient(patient);
                      loadPatientHistory(patient.id);
                    }}
                  >
                    <div className="patient-avatar">👤</div>
                    <div className="patient-info">
                      <h4>{patient.first_name} {patient.last_name}</h4>
                      <p>{patient.email}</p>
                      <p className="patient-phone">{patient.phone || '—'}</p>
                    </div>
                    <div className="patient-arrow">→</div>
                  </div>
                ))}
                {filteredPatients.length === 0 && (
                  <div className="no-data">Пациенты не найдены</div>
                )}
              </div>
            ) : (
              <div className="patient-history">
                <button 
                  className="back-to-patients"
                  onClick={() => {
                    setSelectedPatient(null);
                    setPatientHistory(null);
                  }}
                >
                  ← Назад к списку пациентов
                </button>

                <div className="patient-header">
                  <div className="patient-avatar-large">👤</div>
                  <div className="patient-info-large">
                    <h2>{selectedPatient.first_name} {selectedPatient.last_name}</h2>
                    <p>{selectedPatient.email}</p>
                    <p>{selectedPatient.phone || 'Телефон не указан'}</p>
                    <p className="patient-id">ID: {selectedPatient.id}</p>
                  </div>
                  <button 
                    className="add-result-btn"
                    onClick={() => setShowTestModal(true)}
                  >
                    ➕ Добавить результат
                  </button>
                </div>

                {isLoading ? (
                  <div className="loading-spinner">Загрузка истории...</div>
                ) : (
                  <>
                    {patientHistory?.testResults?.length > 0 && (
                      <div className="history-section">
                        <h3>📊 Результаты анализов</h3>
                        <div className="test-results-list">
                          {patientHistory.testResults.map((result) => (
                            <div key={result.id} className="test-result-card">
                              <div className="test-result-header">
                                <span className="test-result-title">{result.title}</span>
                                <button 
                                  className="delete-result-btn"
                                  onClick={() => deleteTestResult(result.id)}
                                >
                                  🗑️
                                </button>
                              </div>
                              {result.description && (
                                <p className="test-result-desc">{result.description}</p>
                              )}
                              {result.file_url && (
                                <a 
                                  href={getFileUrl(result.file_url)} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="test-result-link"
                                >
                                  📎 Открыть файл
                                </a>
                              )}
                              <span className="test-result-date">
                                {formatDate(result.created_at)}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {patientHistory?.documents?.length > 0 && (
                      <div className="history-section">
                        <h3>📄 Документы</h3>
                        <div className="documents-list">
                          {patientHistory.documents.map((doc) => (
                            <div key={doc.id} className="document-card">
                              <span className="doc-type">{doc.type}</span>
                              <span className="doc-doctor">Врач: {doc.doctor || '—'}</span>
                              {doc.file_url && (
                                <a href={getFileUrl(doc.file_url)} target="_blank" rel="noopener noreferrer">📎 Открыть</a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {patientHistory?.healthMetrics?.length > 0 && (
                      <div className="history-section">
                        <h3>❤️ Показатели здоровья</h3>
                        <div className="health-metrics-list">
                          {patientHistory.healthMetrics.map((metric) => (
                            <div key={metric.id} className="health-metric-card">
                              <div className="metric-date">{formatDate(metric.measured_at)}</div>
                              <div className="metric-values">
                                <span>Давление: {metric.systolic}/{metric.diastolic}</span>
                                <span>Пульс: {metric.pulse}</span>
                                {metric.temperature && <span>Температура: {metric.temperature}°C</span>}
                                {metric.glucose && <span>Глюкоза: {metric.glucose}</span>}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {(!patientHistory?.testResults?.length && 
                      !patientHistory?.documents?.length && 
                      !patientHistory?.healthMetrics?.length) && (
                      <div className="no-data">Нет данных о пациенте</div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {showTestModal && (
        <div className="modal-overlay" onClick={() => setShowTestModal(false)}>
          <div className="test-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>➕ Добавить результат анализа</h3>
              <h4 style={{ color: 'rgba(255,255,255,0.7)', marginTop: '5px' }}>
                для {selectedPatient?.first_name} {selectedPatient?.last_name}
              </h4>
              <button className="modal-close" onClick={() => setShowTestModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Название анализа *</label>
                <input
                  type="text"
                  className="form-input"
                  value={testResultForm.title}
                  onChange={(e) => setTestResultForm({ ...testResultForm, title: e.target.value })}
                  placeholder="Например: Общий анализ крови"
                />
              </div>
              <div className="form-group">
                <label>Описание</label>
                <textarea
                  className="form-textarea"
                  value={testResultForm.description}
                  onChange={(e) => setTestResultForm({ ...testResultForm, description: e.target.value })}
                  rows="3"
                  placeholder="Дополнительная информация о результатах..."
                />
              </div>
              <div className="form-group">
                <label>Файл анализа (PDF, JPG, PNG)</label>
                <input
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  onChange={handleFileChange}
                  className="form-input"
                />
                <p className="ip-hint" style={{ fontSize: '11px', marginTop: '5px' }}>
                  Поддерживаются: PDF, JPG, PNG, GIF. Максимум 10MB
                </p>
              </div>
              {uploadProgress > 0 && uploadProgress < 100 && (
                <div className="upload-progress">
                  <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
                  <span>{uploadProgress}%</span>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowTestModal(false)}>Отмена</button>
              <button className="save-btn" onClick={addTestResult} disabled={!testResultForm.title || isLoading}>
                {isLoading ? (uploadProgress > 0 ? `Загрузка ${uploadProgress}%...` : 'Сохранение...') : '💾 Добавить'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorPanel;